export default __webpack_public_path__ + "static/media/whiteKite.c37cc872.png";